import { ofType } from "redux-observable";
import { mergeMap } from "rxjs/operators";

import "isomorphic-fetch";
import { polyfill } from "es6-promise";
import {
  OFLC_REMOVE_USER_FROM_GROUP,
  removeUserFromGroupSuccess,
  removeUserFromGroupFail,
} from "../actions/actions_removeUserFromGroup";
import { store } from "../../../global/app/store";
import util from "../../../global/utils/Helpers";

polyfill();

let apiIndex = util.isLocalhost()
  ? "http://localhost:9393/auth/graphql"
  : `${util.getCurrentHost()}/auth/auth/graphql`;

const getGroupMasterId = (curretUser) => {
  if (curretUser && curretUser.GroupRole && curretUser.GroupRole === "Master") {
    return curretUser.subject;
  }
};

const getQuery = (thisMember) => {
  let state = store.getState();
  let currtUser = state.appReducer.userDataReducer.data;
  return JSON.stringify({
    query: `mutation {
			removeUserFromGroup(
				group_id:"${currtUser.Group.id}",removeEmail:"${
      thisMember.email
    }", subjectid:"${thisMember.subjectId}", group_owner: "${getGroupMasterId(
      currtUser
    )}"
			)
		  }`,
  });
};

const removeUserFromGroupEpic = (action$) =>
  action$.pipe(
    ofType(OFLC_REMOVE_USER_FROM_GROUP),
    mergeMap((action) =>
      fetch(apiIndex, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: getQuery(action.payload),
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.data.removeUserFromGroup === 403) {
            return removeUserFromGroupFail(data);
          }
          return removeUserFromGroupSuccess(data);
        })
        .catch((error) => removeUserFromGroupFail(true))
    )
  );

export default removeUserFromGroupEpic;
